import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    map: ["T_Cardboard_Light_Denoised_A.jpg", {
        repeat: new Vector2(20, 20)
    }],
    roughnessMap: ["T_CorrugatedCardboard_R.jpg", {
        repeat: new Vector2(20, 20)
    }],
    normalMap: ["T_CorrugatedCardboard_N.jpg", {
        repeat: new Vector2(20, 20)
    }],
    aoMap: ["T_Liner_AO.jpg", {
        channel: 1,
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#FFFFFF"),
        metalness: 0,
        roughness: 1,
        normalScale: new Vector2(0.25, 0.25),
        envMapIntensity: 1,
    });
}